
/**
 * Validates an email address format 
 * 
 * @param email - The email address to validate
 * @returns boolean - True if email is valid, false otherwise
 */
export const isValidEmail = (email: string): boolean => {
  if (!email) return false;
  
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(email)) return false;
  
  const trimmedEmail = email.trim().toLowerCase();
  
  if (trimmedEmail.includes('..')) return false;
  
  const [local, domain] = trimmedEmail.split('@');
  if (!local || !domain) return false;
  if (domain.length < 2) return false;
  
  const allowedDomains = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'outlook.com',
    'aol.com',
    'icloud.com',
    'protonmail.com',
    'yopmail.fr',
    'mail.com'
  ];
  
  const isAllowedDomain = allowedDomains.includes(domain) || 
                          domain.split('.').length >= 2;
  
  return isAllowedDomain;
};

/**
 * Validates a booking reference format
 * 
 * @param ref - The booking reference to validate
 * @returns boolean - True if booking reference is valid, false otherwise
 */
export const isValidBookingRef = (ref: string): boolean => {
  if (!ref) return false;
  
  // Booking reference must be between 6 and 10 characters
  if (ref.length < 6 || ref.length > 10) return false;
  
  // Additional validation rules can be added here
  
  return true;
};
